import { Outlet } from 'react-router-dom'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'

import CollectionsBootstrap from 'modules/one_on_ones/lib/CollectionsBootstrap'
import { OneOnOnesContextProvider } from 'modules/one_on_ones/lib/context/OneOnOnesContextProvider'
import { useOneOnOnesContext } from 'modules/one_on_ones/lib/hooks/useOneOnOnesContext'

const OneOnOnesRootPageWrapper = () => {
  const { canSeeOneOnOnes, loading } = useOneOnOnesContext()

  if (loading) {
    return null
  }

  return (
    <AuthorizeUser authorizeFn={() => canSeeOneOnOnes}>
      <Outlet
        context={{
          loading: false,
        }}
      />
    </AuthorizeUser>
  )
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <OneOnOnesContextProvider>
        <OneOnOnesRootPageWrapper />
      </OneOnOnesContextProvider>
    </CollectionsBootstrap>
  )
}

export default RootPage
